import { userApiPost } from './apiPost'

export const getRules = userApiPost('get-rules')

export const getEubaRules = userApiPost('get-euba-rules')

export const updateRules = userApiPost('update-rule')

export const getMatchedProviderClient = userApiPost('get-matched')

export const createMatchedProviderClient = userApiPost('create-matched')

export const updateMatchedProviderClient = userApiPost('update-matched')

export const getRuleTargets = userApiPost('get-rule-targets')
export const createRuleTarget = userApiPost('create-rule-target')
export const updateRuleTarget = userApiPost('update-rule-target')
export const deleteRuleTarget = userApiPost('delete-rule-target')
